export default function connectToWebsocket({next, store, to}) {
    if (!store.state.websocket.isConnected) {
        Quiz.app.connect().then(() => {
            next()
        }).catch((err) => {
            console.log('error ' + err)
            next({
                path: '/500',
                query: {
                    redirect: to.fullPath,
                }
            })
        })
    } else {
        next()
    }
}